/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import { useToast } from '../../../../context/ToastContext';

/*Import Requisição API*/
import api from '../../../../api';

export default function ProdutosEestoque() {

    const [produtos, setProdutos] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(null);
    const [texto, setTexto] = useState('');
    const [usuario_id, setIdUsuario] = useState();
    const [modalAberto, setModalAberto] = useState(false);
    const [idProdutoParaExcluir, setIdProdutoParaExcluir] = useState(null);
    const caixaDeDialogo = useRef(null);
    const navigate = useNavigate();
    const [termoPesquisa, setTermoPesquisa] = useState('');
    const { showToast } = useToast();

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const abrirModalExcluir = (id_produto) => {
        setIdProdutoParaExcluir(id_produto);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const confirmarExcluirProduto = async () => {
        try {
            console.log('Excluindo produto com ID:', idProdutoParaExcluir);
            const res = await api.delete(`/produto/${idProdutoParaExcluir}`, {
                data: { usuario_id },
            });
            if (res.data.success) {
                showToast('Ação concluída com sucesso!', 'success');
                setProdutos(prev => prev.filter(p => p.id_produto !== idProdutoParaExcluir));
            } else {
                showToast('Ocorreu um erro ao realizar a ação!', 'error');
            } 
            fecharModal();
        } catch (error) {
            console.error('Erro ao excluir produto:', error);
            fecharModal();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    const cadastroProduto = async () => {
        navigate('/menu/produtos_e_estoque/cadastroproduto')
    }

    const adicionarEstoque = () => {
        navigate('/menu/produtos_e_estoque/adicionar_estoque')
    }

    const edicaoMassa = () => {
        navigate('/menu/produtos_e_estoque/edicao-massa');
    }

    const downloadTemplate = () => {
        const templateData = [
            {
                // Campos Básicos do Produto
                nome: 'Exemplo de Produto 1',
                descricao: 'Descrição curta do produto',
                descricaoLonga: 'Descrição longa e detalhada do produto com informações completas sobre características, benefícios, modo de uso, etc.',
                codigoBarras: '1234567890123',
                marca: 'Marca do Produto',
                status: 'ativo',
                idCategoria: 1,
                idFornecedor: 1,
                
                // Variação 1 - Campo principais
                tamanho_1: 'P',
                cor_1: 'Preto',
                material_1: 'Algodão',
                tipo_1: 'Solteiro',
                unidades_por_pacote_1: 1,
                preco_compra_1: 25.00,
                preco_varejo_1: 79.90,
                preco_atacado_1: 59.90,
                estoque_1: 100,
                sku_1: 'SKU001-P-PR',
                peso_1: 500,
                altura_1: 30,
                largura_1: 20,
                profundidade_1: 10,
                
                // Variação 2
                tamanho_2: 'M',
                cor_2: 'Branco',
                material_2: 'Algodão',
                tipo_2: 'Solteiro',
                unidades_por_pacote_2: 1,
                preco_compra_2: 25.00,
                preco_varejo_2: 79.90,
                preco_atacado_2: 59.90,
                estoque_2: 80,
                sku_2: 'SKU001-M-BR',
                peso_2: 550,
                altura_2: 35,
                largura_2: 20,
                profundidade_2: 10,
                
                // Variação 3
                tamanho_3: 'G',
                cor_3: 'Azul',
                material_3: 'Algodão',
                tipo_3: 'Casal',
                unidades_por_pacote_3: 1,
                preco_compra_3: 25.00,
                preco_varejo_3: 79.90,
                preco_atacado_3: 59.90,
                estoque_3: 60,
                sku_3: 'SKU001-G-AZ',
                peso_3: 600,
                altura_3: 40,
                largura_3: 20,
                profundidade_3: 10
            }
        ];

        const ws = XLSX.utils.json_to_sheet(templateData);
        
        // Aumentar largura das colunas para melhor visualização
        ws['!cols'] = [
            { wch: 25 }, // nome
            { wch: 30 }, // descricao
            { wch: 50 }, // descricaoLonga
            { wch: 15 }, // codigoBarras
            { wch: 15 }, // marca
            { wch: 12 }, // status
            { wch: 12 }, // idCategoria
            { wch: 12 }, // idFornecedor
            { wch: 12 }, // tamanho_1
            { wch: 12 }, // cor_1
            { wch: 12 }, // material_1
            { wch: 12 }, // tipo_1
            { wch: 18 }, // unidades_por_pacote_1
            { wch: 15 }, // preco_compra_1
            { wch: 15 }, // preco_varejo_1
            { wch: 15 }, // preco_atacado_1
            { wch: 10 }, // estoque_1
            { wch: 15 }, // sku_1
            { wch: 10 }, // peso_1
            { wch: 10 }, // altura_1
            { wch: 10 }, // largura_1
            { wch: 12 }, // profundidade_1
            { wch: 12 }, // tamanho_2
            { wch: 12 }, // cor_2
            { wch: 12 }, // material_2
            { wch: 12 }, // tipo_2
            { wch: 18 }, // unidades_por_pacote_2
            { wch: 15 }, // preco_compra_2
            { wch: 15 }, // preco_varejo_2
            { wch: 15 }, // preco_atacado_2
            { wch: 10 }, // estoque_2
            { wch: 15 }, // sku_2
            { wch: 10 }, // peso_2
            { wch: 10 }, // altura_2
            { wch: 10 }, // largura_2
            { wch: 12 }, // profundidade_2
            { wch: 12 }, // tamanho_3
            { wch: 12 }, // cor_3
            { wch: 12 }, // material_3
            { wch: 12 }, // tipo_3
            { wch: 18 }, // unidades_por_pacote_3
            { wch: 15 }, // preco_compra_3
            { wch: 15 }, // preco_varejo_3
            { wch: 15 }, // preco_atacado_3
            { wch: 10 }, // estoque_3
            { wch: 15 }, // sku_3
            { wch: 10 }, // peso_3
            { wch: 10 }, // altura_3
            { wch: 10 }, // largura_3
            { wch: 12 }  // profundidade_3
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Produtos');
        XLSX.writeFile(wb, 'template_produtos.xlsx');
        showToast('Template baixado com sucesso!', 'success');
    };

    const handleUploadExcel = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    if (jsonData.length === 0) {
                        showToast('Arquivo vazio!', 'error');
                        return;
                    }

                    // Validar dados obrigatórios
                    const dadosValidos = jsonData.every(produto => 
                        produto.nome && produto.descricao && produto.preco_varejo_1 && produto.estoque_1 !== undefined && Number(produto.unidades_por_pacote_1) > 0
                    );

                    if (!dadosValidos) {
                        showToast('Alguns produtos estão faltando dados obrigatórios (nome, descricao, preco_varejo_1, estoque_1, unidades_por_pacote_1)', 'error');
                        return;
                    }

                    // Processar produtos e variações
                    const produtosProcessados = jsonData.map(produtoExcel => {
                        const variacoes = [];
                        
                        // Processar até 150 variações
                        for (let i = 1; i <= 200; i++) {
                            const tamanhoKey = `tamanho_${i}`;
                            const corKey = `cor_${i}`;
                            const materialKey = `material_${i}`;
                            const tipoKey = `tipo_${i}`;
                            const unidadesPorPacoteKey = `unidades_por_pacote_${i}`;
                            const precoCompraKey = `preco_compra_${i}`;
                            const precoVarejoKey = `preco_varejo_${i}`;
                            const precoAtacadoKey = `preco_atacado_${i}`;
                            const estoqueKey = `estoque_${i}`;
                            const skuKey = `sku_${i}`;
                            const pesoKey = `peso_${i}`;
                            const alturaKey = `altura_${i}`;
                            const larguraKey = `largura_${i}`;
                            const profundidadeKey = `profundidade_${i}`;

                            // Se houver pelo menos um campo de variação preenchido
                            if (produtoExcel[precoVarejoKey] || produtoExcel[estoqueKey]) {
                                variacoes.push({
                                    tamanho: produtoExcel[tamanhoKey] || '',
                                    cor: produtoExcel[corKey] || '',
                                    material: produtoExcel[materialKey] || '',
                                    tipo: produtoExcel[tipoKey] || '',
                                    unidades_por_pacote: parseInt(produtoExcel[unidadesPorPacoteKey], 10) || 0,
                                    preco_compra: produtoExcel[precoCompraKey] || 0,
                                    preco_varejo: produtoExcel[precoVarejoKey] || 0,
                                    preco_atacado: produtoExcel[precoAtacadoKey] || 0,
                                    estoque: produtoExcel[estoqueKey] || 0,
                                    sku: produtoExcel[skuKey] || '',
                                    peso: produtoExcel[pesoKey] || 0,
                                    altura: produtoExcel[alturaKey] || 0,
                                    largura: produtoExcel[larguraKey] || 0,
                                    profundidade: produtoExcel[profundidadeKey] || 0
                                });
                            }
                        }

                        return {
                            nome: produtoExcel.nome,
                            descricao: produtoExcel.descricao,
                            descricaoLonga: produtoExcel.descricaoLonga || '',
                            codigoBarras: produtoExcel.codigoBarras || '',
                            marca: produtoExcel.marca || '',
                            status: produtoExcel.status || 'ativo',
                            idCategoria: produtoExcel.idCategoria || '',
                            idFornecedor: produtoExcel.idFornecedor || '',
                            variacoes: variacoes.length > 0 ? variacoes : [
                                {
                                    tamanho: '',
                                    cor: '',
                                    material: '',
                                    tipo: '',
                                    unidades_por_pacote: 1,
                                    preco_compra: 0,
                                    preco_varejo: 0,
                                    preco_atacado: 0,
                                    estoque: 0,
                                    sku: '',
                                    peso: 0,
                                    altura: 0,
                                    largura: 0,
                                    profundidade: 0
                                }
                            ]
                        };
                    });

                    // Redirecionar para página de preview
                    navigate('/menu/produtos_e_estoque/preview-importacao', {
                        state: { 
                            produtosProcessados,
                            usuario_id
                        }
                    });
                } catch (error) {
                    console.error('Erro ao processar arquivo:', error);
                    showToast('Erro ao processar arquivo Excel', 'error');
                }
            };
            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error('Erro ao upload:', error);
            showToast('Erro ao fazer upload do arquivo', 'error');
        }
    };

    useEffect(() => {
        async function carregarProdutos() {
            try {
                const response = await api.get('/listarprodutosAdm');
                if (response.data.success) {
                    setProdutos(response.data.produtos);
                } else {
                    setErro(response.data.message || 'Erro ao carregar os produtos.');
                }
            } catch (error) {
                setErro('Erro ao se conectar ao servidor. Tente novamente mais tarde.');
            } finally {
                setCarregando(false);
            }
        }

        carregarProdutos();
    }, []);

    const handleEdit = (id_produto) => {
        console.log('Id enviado', id_produto)
        navigate(`/menu/produtos_e_estoque/editarproduto`, { state: { id_produto } });
    };

    const handleView = (id_produto) => {
        console.log(`Visualizar produto com ID: ${id_produto}`);
        navigate('/menu/produtos_e_estoque/visualizarproduto', { state: { id_produto } });
    };

    const produtosFiltrados = produtos.filter((produto) =>
        produto.nome.toLowerCase().includes(termoPesquisa.toLowerCase())
    );

    return (
        <section className='container-principal-produtosEestoque'>

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse produto?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirProduto}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>


            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <div className='area-de-trabalho-produtos'>
                <section className='conteudo-produtosEestoque'>
                    <div className='titulo-produtosEestoque'><h1>Produtos e Estoque</h1></div>
                    <div className='barraDePesquisa-e-criarProduto-container'>
                        <div className='barraDePesquisa-e-criarProduto-container'>
                            <div className='barraDePesquisa-Produtos'>
                                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#000" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <input
                                    type='text'
                                    placeholder='Pesquiso o produto pelo: Nome'
                                    value={termoPesquisa}
                                    onChange={(e) => setTermoPesquisa(e.target.value)}
                                />
                            </div>
                            <div className='bnts-acoes-container'>
                                <button onClick={adicionarEstoque} className='bnt-adicionarEstoque'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Adicionar Estoque
                                </button>
                                <button onClick={cadastroProduto} className='bnt-cadastrarProduto'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Criar Produto
                                </button>
                            </div>
                        </div>
                    </div>

                    {carregando ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando produtos...</h2>
                        </div>
                    ) : (
                    <div className='tabela-produtos'>
                        {produtosFiltrados.length === 0 ? (
                            <p>Nenhum produto encontrado =&#40;</p>
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Preço Atacado</th>
                                        <th>Preço Compra</th>
                                        <th>Estoque</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {produtosFiltrados.map((produto) => (
                                        <tr className='conteudo' key={produto.id_produto}>
                                            <td className='primeiro'>{produto.nome}</td>
                                            <td>
                                                R${(produto.preco_atacado && !isNaN(Number(produto.preco_atacado)))
                                                    ? Number(produto.preco_atacado).toFixed(2)
                                                    : '0.00'}
                                            </td>
                                            <td>
                                                R${(produto.preco_compra && !isNaN(Number(produto.preco_compra)))
                                                    ? Number(produto.preco_compra).toFixed(2)
                                                    : '0.00'}
                                            </td>
                                            <td>{produto.estoque}</td>
                                            <td className='final'>
                                                <div className='bnts-produtos'>
                                                    <button className='bnt-visualizar' onClick={() => handleView(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg></button>
                                                    <button className='bnt-editar' onClick={() => handleEdit(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                                                    <button className='bnt-excluir' onClick={() => abrirModalExcluir(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /> </svg></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    )}
                </section>
                    <div className='bnts-importacao-container'>
                        <div className='bnts-importacao'>
                            <button className='bnt-download-template' onClick={downloadTemplate}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 15L4 9M10 15L16 9M10 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M3 18H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                Baixar Template
                            </button>

                            <button className='bnt-edicao-massa' onClick={edicaoMassa}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 5H17M3 10H17M3 15H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Edicao em massa
                            </button>
                            
                            <label className='bnt-upload-excel'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 5V15M5 10H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M13 3H4C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Importar Excel
                                <input 
                                    type="file" 
                                    accept=".xlsx,.xls,.csv"
                                    onChange={handleUploadExcel}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </main>

            <Rodape />
        </section>
    );
}
